export const MAX_MEDIA_SELECTION_LIMIT = 40
